import withDefaultClassName from './hoc/withDefaultClassName.jsx';
import { Dropdown, Form, Header } from 'semantic-ui-react';

export const EnhancedDropdown = withDefaultClassName(Dropdown);

export const EnhancedFormField = withDefaultClassName(Form.Field);

export const EnhancedHeaderContent = withDefaultClassName(Header.Content);
